import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';
import { FILTERS_TYPE, } from 'common/types';

export interface ProductAttributeChoiceType {
    name: string;
    code: string;
}

export interface ProductAttributeType {
    name: string;
    code: string;
    choices: Array<ProductAttributeChoiceType>;
}

const setOrderAttributes = (data: Array<ProductAttributeType>) => {
    const order = [
        FILTERS_TYPE.PRIMARY_SCHOOL,
        FILTERS_TYPE.HIGH_SCHOOL,
        FILTERS_TYPE.SCHOOL_SUBJECTS,
        FILTERS_TYPE.BOOK_TYPES,
        FILTERS_TYPE.PRODUCT_TYPE,
        FILTERS_TYPE.BOOK_SERIES,
    ];

    const indexesOfOrderedFilters = order.reduce((indexes: Array<number>, code: string) => {
        const index = data.findIndex(filter => filter.code === code);

        return index > -1 ? [ ...indexes, index ] : [ ...indexes ];
    }, []);

    const length = data.length;
    const indexesOfRestFilters: Array<number> = [];

    for (let index = 0; index < length; index++) {
        if (indexesOfOrderedFilters.indexOf(index) === -1) {
            indexesOfRestFilters.push(index);
        }
    }

    const first = indexesOfOrderedFilters.map(index => data[index]);
    const rest = indexesOfRestFilters.map(index => data[index]);

    return [ ...first, ...rest ];
};

class ProductsAttributes extends BaseRepositoryClass implements RepositoryType {
    get() {
        const transformers = {
            response: [
                JSON.parse,
                setOrderAttributes,
            ],
        };

        return this
            .requester
            .setTransformers(transformers)
            .get<Array<ProductAttributeType>>('products/attributes');
    }
}

export default ProductsAttributes;
